export default (theme) => ({
  root: {},
  avatar: {
    width: '85px',
    height: '85px',
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(1)
    }
  },
  subtitle: {
    color: theme.palette.text.secondary
  },
  content: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center'
    },
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  },
  date: {
    marginTop: theme.spacing(2),
    textAlign: 'left'
  },
  info: {
    margin: theme.spacing(1),
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  buttonFill: {
    display: 'flex',
    '& .MuiButton-root': {
      flex: '1 1 0'
    }
  }
});
